import React from "react";

const FoundationDetails = () => {
  return (
    <>
      <section className="foundation-coruse">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="benefits_membership">
                    <div className="heading mb-3">
                      <h2>Courses</h2>
                    </div>
                    <div className="mb-3">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="my-container">
                              <div className="f-course">
                                  <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                                  <h5><a href="#">BLOCKCHAIN FOR ENERGY AND UTILITIES</a></h5>
                                  <div className="row">
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                  </div>
                              </div>
                              <img src={process.env.PUBLIC_URL + '/images/course/foundation-course-banner.png'} />;
                              {/* <img src="https://indiasmartgrid.org/onlinetrainingprogram/img/Banner-BLOCKCHAIN-FOR-ENERGY-AND-UTILITIES.jpg"/> */}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="my-container">
                              <div className="f-course">
                                  <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                                  <h5><a href="#">CYBER SECURITY FOR POWER SYSTEMS</a></h5>
                                  <div className="row">
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                  </div>
                              </div>
                              <img src="http://placekitten.com/1500/1000"/>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="my-container">
                              <div className="f-course">
                                  <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                                  <h5><a href="#">ARTIFICIAL INTELLIGENCE AND ROBOTICS FOR UTILITIES AND SMART CITIES</a></h5>
                                  <div className="row">
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                  </div>
                              </div>
                              <img src={process.env.PUBLIC_URL + '/images/course/artificial-intelligent-banner-1.png'} />;
                              {/* <img src="https://cruxcreativedemo2.com/isgf/public/source/banner.png"/> */}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="my-container">
                              <div className="f-course">
                                  <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                                  <h5><a href="#">SMART GRID FOUNDATION COURSE</a></h5>
                                  <div className="row">
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                  </div>
                              </div>
                              <img src={process.env.PUBLIC_URL + '/images/course/foundation-course-banner.png'} />;
                              {/* <img src="https://cruxcreativedemo2.com/isgf/public/source/foundation%20course%20banner.png"/> */}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="my-container">
                              <div className="f-course">
                                  <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                                  <h5><a href="#">ADVANCED METERING INFRASTRUCTURE (AMI)</a></h5>
                                  <div className="row">
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                  </div>
                              </div>
                              <img src={process.env.PUBLIC_URL + '/images/course/cat-img.jpg'} />;
                              {/* <img src="http://placekitten.com/1500/1000"/> */}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="my-container">
                              <div className="f-course">
                                  <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                                  <h5><a href="#">ELECTRIC MOBILITY & CHARGING INFRASTRUCTURE</a></h5>
                                  <div className="row">
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                  </div>
                              </div>
                              <img src={process.env.PUBLIC_URL + '/images/course/cat-img.jpg'} />;
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="my-container">
                              <div className="f-course">
                                  <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                                  <h5><a href="#">ELECTRIC MOBILITY & CHARGING INFRASTRUCTURE</a></h5>
                                  <div className="row">
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                  </div>
                              </div>
                              <img src={process.env.PUBLIC_URL + '/images/course/cat-img.jpg'} />;
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="my-container">
                              <div className="f-course">
                                  <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                                  <h5><a href="#">ELECTRIC MOBILITY & CHARGING INFRASTRUCTURE</a></h5>
                                  <div className="row">
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="progress">
                                      <div className="progress-bar"></div>
                                    </div>
                                    </div>
                                  </div>
                              </div>
                              <img src={process.env.PUBLIC_URL + '/images/course/cat-img.jpg'} />;
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-md-4">
              <Sidebar />
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default FoundationDetails;
